export const HOLIDAY_PRIZE_EXPRESS = 'holidayPrizeExpress'

export const holidayPrizeExpressGames = [
  '270',
  '2244',
  '211',
  '204',
  '240',
  '225',
  '226',
  '210',
  '221',
  '222',
  '224',
  '233',
  '234',
  '227',
  '201',
  '206',
  '230',
  '292',
  '950',
  '28401',
  '203',
  '205',
  '545',
  '2501',
  '801',
  '1401',
  '1501',
  '1701',
  '2750',
  '3426',
  '1101',
]
